import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../../environments/environment';

export const authInterceptor: HttpInterceptorFn = (req, next) => {

  // if the token has been stored in sessionStorage...
  const token = localStorage.getItem('access_token');
  

  /**
   * A list of domains to set custom headers and Bearer token, the list must be exclude all domains related to ping identity.
   * If you need to set a custo domain please add into the environment file. 
   */
  const allowedDomains = [environment.apiURL];

  // If the domain exist int the list will add the custom headers
  const isIntheList = allowedDomains.some(domain => req.url.startsWith(domain));

  // const ssoToken = 'haJef6DTMWoVrH8M0w3pcowSVEI.*AAJTSQACMDIAAlNLABxaZHk3L3lQSVAvVXg3K2NZTVo0eVJGRzJONUk9AAR0eXBlAANDVFMAAlMxAAIwMQ..*';

  let headersConfig: Record<string, string> = {
    Authorization: `Bearer ${token}`,
    'x-auth-vendor': 'forgeRock',
    // 'cookie-set': ssoToken
  }

  // If we want to validate the SSO Token we will include the cookie
  // const callingToVerifySSOToken = req.url.includes('/profile/validate');
  // if(callingToVerifySSOToken) {
  //   headersConfig['a1d213d00e6ea91'] = ssoToken;
  // }

  // Update password flow
  const initialStepFlow = req.url.includes('/profile/update-password') || req.url.includes('/profile/mfa-registration');

  if(initialStepFlow) {
    const url = new URL(req.url, window.location.origin);
    const queryParams = new URLSearchParams(url.search);
    const initialStep = queryParams.get('flow')
    if(initialStep === 'init') {
      headersConfig['X-OpenAM-Username'] = 'demouser12@yopmail.com';
    }
  }

  if (isIntheList) {
    if (token) {
      const cloned = req.clone({
        setHeaders: headersConfig
      });
      return next(cloned);
    }    
  }
  return next(req);
};
